import { inject } from 'mobx-react';
import { useState, useEffect } from 'react';
import { isGuestCountValid } from '../utils/guest-count-validity';

const GuestCountInput = ({ data, numberOfGuests, onUpdate, onValidationChange, required = false }) => {
  const [error, setError] = useState(!isGuestCountValid(numberOfGuests, required));
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    const isValid = isGuestCountValid(numberOfGuests, required);
    setError(!isValid);
    if (onValidationChange) {
      onValidationChange('numberOfGuests', isValid);
    }
  }, [numberOfGuests, onValidationChange, required]);

  const handleChange = (e) => {
    setTouched(true);
    onUpdate(e.target.value);
  };

  return (
    <div className='d-flex pb-2'>
      <div className='report-label col-2'>
        {data.t.read('review_expense.number_of_guests.label')}{required ? ' *' : ''}
      </div>
      <div className='col-8'>
        <input
          className={`form-control ${error && touched ? 'is-invalid' : ''}`}
          placeholder={data.t.read('review_expense.number_of_guests.placeholder')}
          value={numberOfGuests}
          required={required}
          type='number'
          name='numberOfGuests'
          onChange={handleChange}
          onBlur={() => setTouched(true)}
          step='1'
          min='0'
          max='10'
        />
        {touched && error && (
          <div data-testid="guest-count-error" className="text-danger mt-1 pl-1">
            {data.t.read('form_errors.required_field')}
          </div>
        )}
      </div>
    </div>
  );
};

export default inject('data')(GuestCountInput);
